import React from 'react'
import { TableRow } from './TableRow'
import { DataTable } from '../../DataTable/DataTable'
import type { History } from '@ztechapps/common.contract'
import type { UseListResult } from '@ztechapps/common.hook'
import type { TableHeight } from '../../DataTable/types'
import { fieldsConfig } from '../constants'

export type HistoryListProps = {
  items?: History[]
  height?: TableHeight
} & UseListResult<History>

export const HistoryList = ({ items, height, ...rest }: HistoryListProps) => {
  height = height ?? { topMargin: 380 }

  return (
    <DataTable
      tableOptions={{
        width: '100%',
        responsive: true,
      }}
      name="history-list-v1"
      fields={fieldsConfig}
      listResult={{ list: items, ...rest }}
      height={height}
      stats={'history item(s)'}
      row={TableRow}
    />
  )
}
